// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".modal[data-v-060e8e18]{z-index:999}.modal-card-body[data-v-060e8e18]{flex-direction:column;min-height:50vh}.modal-card[data-v-060e8e18]{min-width:60%;max-width:80%}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
